import { CURRENCY_VARIABLE_METADATA } from './currency.variables'
import type { DocumentVariableMetadata } from './document-variable'
import { LUGAR_VARIABLE_METADATA } from './lugar.variables'
import {
  ADVISOR_VARIABLE_METADATA,
  DOCUMENT_VARIABLE_METADATA,
  OTHER_VARIABLE_METADATA,
  OWNER_VARIABLE_METADATA,
  PROJECT_VARIABLE_METADATA,
  SOCIETY_VARIABLE_METADATA
} from './misc.variables'
import { NEGOTIATION_VARIABLE_METADATA } from './negotiation.variables'
import { PROPERTY_VARIABLE_METADATA } from './property.variables'
import {
  CIERRE_VARIABLE_METADATA,
  REPRESENTANTE_VARIABLE_METADATA
} from './representante.variables'
import { TITULAR_VARIABLE_METADATA } from './titular.variables'

/**
 * EL CATÁLOGO DE DOCUMENTOS, compuesto. Espeja `shared/variables/registry.ts` y en el MISMO orden.
 *
 * El orden no es cosmético: es el que ve el picker del editor —categoría por categoría, y dentro
 * de cada una el orden de declaración—, así que alterarlo movería cosas de lugar en una pantalla
 * que está en producción.
 *
 * ⚠️ Esto NO es un barril (regla 5 del monorepo): no reexporta los módulos, compone un valor
 * nuevo. Para leer un dominio se importa su archivo, como hace este mismo archivo.
 */
export const ALL_DOCUMENT_VARIABLE_METADATA: DocumentVariableMetadata[] = [
  ...SOCIETY_VARIABLE_METADATA,
  ...REPRESENTANTE_VARIABLE_METADATA,
  ...PROJECT_VARIABLE_METADATA,
  ...PROPERTY_VARIABLE_METADATA,
  ...NEGOTIATION_VARIABLE_METADATA,
  ...LUGAR_VARIABLE_METADATA,
  ...CURRENCY_VARIABLE_METADATA,
  ...OWNER_VARIABLE_METADATA,
  ...TITULAR_VARIABLE_METADATA,
  ...ADVISOR_VARIABLE_METADATA,
  ...DOCUMENT_VARIABLE_METADATA,
  ...CIERRE_VARIABLE_METADATA,
  ...OTHER_VARIABLE_METADATA
]

/** Índice por key. Lo usa el adaptador del host para colgarle el `resolve` a cada metadato. */
export const DOCUMENT_VARIABLE_METADATA_BY_KEY: ReadonlyMap<string, DocumentVariableMetadata> =
  new Map(ALL_DOCUMENT_VARIABLE_METADATA.map((variable) => [variable.key, variable]))
